import type { EventView } from "~/business-areas/event/composables/event-view.hook";
import type { ContactFlowMetadata } from "~~/model/analytics.model";

const POST_APPLICATION_QUERY_PARAMETER_KEY = "applied";

export function useEventApplication(
  event: Pick<EventView, "_links" | "slug" | "is_sold_out" | "is_upcoming">,
) {
  const { state } = useGrowthContact();
  const applications = useCookie<
    {
      email: string;
      slug: string;
    }[]
  >("pollen_event_applications", {
    default: () => [],
  });
  const router = useRouter();
  const route = useRoute();
  const redirect = computed(
    () =>
      `${router.resolve(event._links.page).path}?${POST_APPLICATION_QUERY_PARAMETER_KEY}=true`,
  );

  const hasApplied = computed(() =>
    applications.value.some((application) => {
      return (
        application.email === state.value?.email &&
        application.slug === event.slug
      );
    }),
  );

  function apply() {
    if (!state.value?.email) return;

    applications.value.push({
      email: state.value.email,
      slug: event.slug,
    });

    return navigateTo({
      query: {
        ...route.query,
        applied: undefined,
      },
    });
  }

  if (route.query[POST_APPLICATION_QUERY_PARAMETER_KEY] === "true") apply();

  const ctaBindings = computed<
    ContactFlowMetadata & {
      redirect: string;
      hasApplied: boolean;
      isSoldOut: boolean;
    }
  >(() => {
    return {
      origin: "events",
      origin_page_action: "apply_cta",
      origin_page_id: event.slug,
      redirect: redirect.value,
      hasApplied: hasApplied.value,
      isSoldOut: !!event.is_sold_out && event.is_upcoming,
    };
  });

  return {
    ctaBindings,
  };
}
